import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import router from "@/router";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";



export interface GPT {
  irbId: number;
  irbMessage: string;
}


export interface IrbGptInfo {
  
  irbGptInfo;
}


@Module
export default class IrbGptInfoModule
  extends VuexModule
  implements IrbGptInfo {
  irbGptInfo = {};
  

  /**
   * Get current applications
   * @returns Array<Application>
   */
  get currentGptInfo() {
    console.log(this.irbGptInfo);
    return this.irbGptInfo;
  }


  

  @Mutation
  [Mutations.SET_IRB_GPT_INFO](irbGptInfo) {
    this.irbGptInfo = irbGptInfo;
  }

  

  @Action
  [Actions.POST_IRB_GPT](data) {
    return new Promise<void>((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("irb/irbgpt", data)
          .then(({ data }) => {
            this.context.commit(Mutations.SET_IRB_GPT_INFO, data);
            resolve();
          })
          .catch(({ response }) => {

            this.context.commit(Mutations.SET_IRB_ERROR, data);
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_IRB_ERROR, {});
        reject();
      } 
    });
  }

}
